import React, { useRef, useState, useEffect } from 'react';
import AppLayout from './AppLayout';
import { createIndex, search } from './search.tsx';
import { SEARCH_SORT_SCORE_ALPHA } from '../../modules/App/search.tsx';

export default function App({ organisationData }) {
  const ref = useRef(null);

  const [searchTerm, setSearchTerm] = useState(null);
  const [sort, setSort] = useState(SEARCH_SORT_SCORE_ALPHA);
  const [results, setResults] = useState([]);
  const [index, setIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const index = createIndex(organisationData);

    setIndex(index);

    // If ?query is set then extract and carry out a search
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('query');

    if (query) {
      setSearchTerm(query);
    } else {
      setSearchTerm('');
    }
  }, []);

  useEffect(() => {
    if (index) {
      setResults(search(index, searchTerm, sort));
    }
  }, [searchTerm, sort]);

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value.trim());
    setCurrentPage(1);
  };
  const handleSortChange = (e) => setSort(e.target.value);
  const handlePageChange = (e) => setCurrentPage(e.target.value);

  return (
    <div className="bootstrap-react" ref={ref}>
      <AppLayout
        handleSearchTermChange={handleSearchTermChange}
        handleSortChange={handleSortChange}
        handlePageChange={handlePageChange}
        results={results}
        searchTerm={searchTerm}
        currentPage={currentPage}
      ></AppLayout>
    </div>
  );
}
